// apps/web/src/routes/$lang/_layout/stays.booking.$reference.tsx
import { createFileRoute } from "@tanstack/react-router";
import { StayManagePage } from "../../../features/stays/pages/stay-manage-page";

/**
 * The link in the booking confirmation email points here:
 * `${SITE_ORIGIN}/${lang}/stays/booking/${reference}`. Guests book without
 * an account, so `reference` is the only credential this route carries —
 * everything else (holder identity for cancellation) is re-proven on the
 * page itself via the holder's email, not via this URL.
 */
export const Route = createFileRoute("/$lang/_layout/stays/booking/$reference")({
  component: StayManagePage,
});
